import styled from 'styled-components';

export const EarnTopWrapper = styled.div`
  position: relative;
  > div {
    position: relative;
    z-index: 1;
  }
  ::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    background: url('/earn/background-cropped.svg') left center no-repeat;
    background-size: cover;
    z-index: 0;
  }
`;
